import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";

interface Props {
    title: string;
    description?: string;
}

export function CreditNoteBanner({ title, description }: Props) {
    return (
        <div className="flex items-start gap-3 rounded-xl border border-primaryborder bg-primarysurface px-5 py-4">
            <ArrowUturnLeftIcon
                className="mt-0.5 h-5 w-5 shrink-0 text-primary"
                aria-hidden="true"
            />
            <div className="flex flex-col gap-1">
                <p className="text-sm font-semibold text-gray-900">{title}</p>
                {description && <p className="text-sm text-gray-500">{description}</p>}
            </div>
        </div>
    );
}
